export default __webpack_public_path__ + "static/media/buttonSoundClick.1ef9a63b.mp3";